import { ToastrService } from 'ngx-toastr';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NotifyService {

  constructor(
    private toast: ToastrService
  ) { }

  error(title: string, message: string) {
    this.toast.error(message, title)
  }

  warning(title: string, message: string) {
    this.toast.warning(message, title)
  }

  success(title: string, message: string) {
    this.toast.success(message, title)
  }
}
